export default __webpack_public_path__ + "static/media/kthesaurus.d8d8228e.png";